/* AVOREL — Journal signup popup behaviour */
(function(){
  var COMPANY='SzBZYj';
  var LIST='RA4VPB';
  var SUB_KEY='av_journal_sub';
  var DIS_KEY='av_journal_dismiss';
  var COOLDOWN=30*24*60*60*1000;
  var DELAY=12000;

  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  ready(function(){
    var root=document.getElementById('avpRoot');
    if(!root) return;
    // suppression rules
    try{
      if(localStorage.getItem(SUB_KEY)==='1') return;
      var last=parseInt(localStorage.getItem(DIS_KEY)||'0',10);
      if(last && (Date.now()-last) < COOLDOWN) return;
    }catch(e){}

    var timer=setTimeout(open, DELAY);
    var bodyEl=document.getElementById('avpBody');
    var form=document.getElementById('avpForm');
    var email=document.getElementById('avpEmail');
    var btn=document.getElementById('avpBtn');

    function open(){
      root.classList.add('is-open');
      root.setAttribute('aria-hidden','false');
      // force reflow then animate in
      void root.offsetWidth;
      root.classList.add('is-in');
      document.addEventListener('keydown', onKey);
    }
    function dismiss(){
      root.classList.remove('is-in');
      try{ localStorage.setItem(DIS_KEY, String(Date.now())); }catch(e){}
      setTimeout(function(){ root.classList.remove('is-open'); root.setAttribute('aria-hidden','true'); }, 380);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e){ if(e.key==='Escape') dismiss(); }

    [].slice.call(root.querySelectorAll('[data-avp-close]')).forEach(function(el){ el.addEventListener('click', dismiss); });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      var val=(email.value||'').trim();
      if(!val || val.indexOf('@')<1){ email.focus(); btn.textContent='A valid email, please'; return; }
      btn.disabled=true; btn.textContent='Joining\u2026';
      var payload={data:{type:'subscription',attributes:{custom_source:'Avorel Journal Popup',profile:{data:{type:'profile',attributes:{email:val}}}},relationships:{list:{data:{type:'list',id:LIST}}}}};
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+COMPANY,{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(payload)})
        .then(function(r){
          if(r.status>=200 && r.status<300){
            try{ localStorage.setItem(SUB_KEY,'1'); }catch(e){}
            root.classList.add('is-done');
            setTimeout(function(){ root.classList.remove('is-in'); setTimeout(function(){ root.classList.remove('is-open'); },380); }, 3200);
          } else { throw new Error('bad'); }
        })
        .catch(function(){ btn.disabled=false; btn.textContent='Please try again'; });
    });
  });
})();